module.exports = __webpack_public_path__ + "img/growcify-website-14-banner.0030aa31.png";